import { render, staticRenderFns } from "./DrawFab.vue?vue&type=template&id=49edbf1e&lang=pug&"
import script from "./DrawFab.vue?vue&type=script&lang=js&"
export * from "./DrawFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DrawFab.vue"
export default component.exports